var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 10H15H19.5C19.241 8.075 17.844 5.337 16.5 4C15.163 2.663 12.925 1.766 11 1.5M9.5 19.5V1.5C7.4 1.766 5.4 2.418 4 4C2.6 5.582 1.5 8.365 1.5 10.5C1.5 12.635 2.1 14.418 3.5 16C4.9 17.589 7.4 19.241 9.5 19.5ZM11 19.5C12.925 19.255 15.649 18.344 17 17C18.344 15.649 19.255 12.925 19.5 11H11M10.5 21C9.051 21 7.686 20.7235 6.405 20.1705C5.131 19.6245 4.0215 18.879 3.0765 17.934C2.1315 16.989 1.3825 15.876 0.8295 14.595C0.2765 13.321 0 11.956 0 10.5C0 9.044 0.2765 7.679 0.8295 6.405C1.3825 5.131 2.1315 4.0215 3.0765 3.0765C4.0215 2.1315 5.131 1.3825 6.405 0.8295C7.686 0.2765 9.051 0 10.5 0C11.949 0 13.3105 0.2765 14.5845 0.8295C15.8515 1.3825 16.961 2.135 17.913 3.087C18.872 4.039 19.6245 5.1485 20.1705 6.4155C20.7235 7.6895 21 9.051 21 10.5C21 11.935 20.7235 13.293 20.1705 14.574C19.6245 15.848 18.879 16.961 17.934 17.913C16.989 18.872 15.876 19.6245 14.595 20.1705C13.321 20.7235 11.956 21 10.5 21Z",
    fill: "#E9EDF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/Report.035892331d8a30cfbfc42ad59bf9f65a.svg";
export { ForwardRef as ReactComponent };